/**
 * 公共工具函数文件
 */

/**
 * route.params.xxx的值若包含.html则去掉。比如 ：route.params.id = 123456789.html，则把.html去掉，返回123456789
 * @param str 包含.html的字符串
 * @returns 
 */
export const deleteHtml = (str: string) => {
    if (str.indexOf('.') !== -1) {
        return str.substring(0, str.indexOf('.'))
    }
    return str;
}

/**
 * 
 * @param url 被打开的url
 */
export const openUrl = (url: string) => {
    const host = window.location.host;
    if (!host.includes('www')) {
        url = url.replace('.html', '');
    } else {
        url = url.replace(import.meta.env.VITE_WWW_HOST, '');
    }
    window.open(url);
}

/**
 * 被匹配的字符串的某个字符高亮， 比如字符串是：val = 你好，keyword = 好，则“好”高亮显示
 * @param val 原字符串
 * @param keyword 字符串的某个字符
 * @returns 
 */
export const brightenKeyword = (val: string, keyword: string) => {
    const Reg = new RegExp(keyword, 'i');
    if (val) {
        return val.replace(Reg, `<span style="color: #409EFF; font-size:14px;">${keyword}</span>`);
    }
}

/**
 * 判断时间是否过去15天
 * @param dateString 时间字符串，格式：2024-04-06 11:34:00
 */
export const hasPassedFifteenDays = (dateString: string) => {
    dateString = dateString?.replace(/-/g, '/');
    const orderTime = new Date(dateString).getTime();
    const nowTime = Date.now();
    return nowTime - orderTime > 86400000 * 15;
}   

/**
 * 判断当前访问的设备是否是移动端
 */
export const isMobileDevice = () => {    
    const userAgent = navigator.userAgent;  
    const mobileRegex = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;  
    return mobileRegex.test(userAgent.toLowerCase());  
} 